export const SEARCH_FACET_ATTRIBUTES = [
  {
    attribute: 'type',
    field: 'aggregated_type',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
        include: ['news', 'article', 'opinion', 'download', 'interview', 'theme'],
      },
    }),
  },
  {
    attribute: 'theme_name',
    field: 'theme_name',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
  {
    attribute: 'pillar_name',
    field: 'pillar_name',
    type: 'string',
    facetQuery: (
      field,
      size,
    ) => ({
      terms: {
        field,
        size,
        min_doc_count: 0,
      },
    }),
  },
];

export const SEARCH_SORTING_OPTIONS = {
  default: {
    field: '_score',
    order: 'desc',
  },
  _created_desc: {
    field: 'created',
    order: 'desc',
  },
};

export const SEARCH_RESULT_ATTRIBUTES = [
  'url',
  'aggregated_type',
  'title',
  'body',
  'created',
  'taxonomy_name',
  'taxonomy_description',
];

export const SEARCH_SEARCH_ATTRIBUTES = [
  'title',
  'paragraph_title',
  'body',
  'paragraph_body',
  'paragraph_body_cta',
  'paragraph_text',
  'paragraph_attachments',
  'taxonomy_name',
  'taxonomy_description',
  'taxonomy_paragraph_body',
  'taxonomy_paragraph_body_cta',
  'taxonomy_paragraph_text',
  'taxonomy_paragraph_title',
];

export const TYPE_NAME_MAPPING = {
  news: 'Nieuws',
  article: 'Artikel',
  opinion: 'Opinie',
  download: 'Download',
  interview: 'Interview',
  theme: 'Thema',
  landing_page: 'Pagina',
  paragraph_page: 'Pagina',
};

const decay = 0.75;
const scale = '1095d';

export const SEARCH_REQUEST_OPTIONS = {
  hooks: {
    beforeSearch: (requests) => {
      // Per 5 years, we decrease the scoring by 25%
      // This way, older articles become less relevant
      requests.forEach((request) => {
        const { query } = request.body;
        delete request.body.query;

        request.body.query = {
          function_score: {
            query,
            functions: [
              {
                gauss: {
                  created: {
                    origin: 'now',
                    scale: scale,
                    decay: decay,
                  },
                },
              },
            ],
          },
        };
      });
      return new Promise((resolve) => {
        resolve(requests);
      });
    },
  },
};
